import { FunctionalComponent } from 'preact';
import { stylesheet } from 'astroturf';
import ColorButtonGradient from '##/assets/images/color-button-gradient.svg';

const styles = stylesheet`
  @import '##/styles/import.scss';

  .buttons {
    width: 100%;
    position: fixed;
    bottom: pxToVh(-1);
    right: 0;
  }
`;

const HbbTVButtonOverlay: FunctionalComponent = () => (
  <ColorButtonGradient className={styles.buttons} />
);

export default HbbTVButtonOverlay;
